import React, {useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { trackClaim } from '../../store/reducers/claimReducer';
import './TrackClaim.css';


// const claimEvents = [
//     { title: 'Assistance Created', datetime: '15 Nov 2025 | 11:28:31 AM' },
//     { title: 'Vendor Assigned', datetime: '15 Nov 2025 | 11:33:32 AM' },
//     { title: 'On the way to Incident', datetime: '15 Nov 2025 | 11:34:59 AM' },
//     { title: 'On the way to Drop', datetime: '15 Nov 2025 | 11:38:23 AM', highlight: true },
//     { title: 'Case Closed', datetime: '15 Nov 2025 | 11:44:34 AM' }
//   ];
  const TrackClaim = () => {
    const dispatch = useDispatch();
    const location = useLocation();
  
    const { assistNo = '', userId: initialUserId = '' } = useSelector((state) => state.claimList.navigationData);
    let userId = initialUserId || localStorage.getItem('trackUserd') || '';
  
    const { response, trackClaimloading } = useSelector((state) => state.claimList);
    const trackClaimData = response?.data || {};
    const trackHistory = trackClaimData?.ActiveRSATimeLine || [];
    const userData = response.user ?? {};
  
    useEffect(() => {
      if (assistNo) {
        // const requestData = { assistance_no: 'AT0809250000000019' };
        const requestData = { assistance_no: assistNo };
        dispatch(trackClaim(requestData));
      }
    }, [dispatch, assistNo]);
  
    return (
      <div className="claim-history-container">
        <div className="claim-header">
          <div>
            <label className="font14 regular opacity-reduce">User ID: </label>
            <span className="font14 regular opacity">{userId?.toString()}</span>
          </div>
          <div>
            <label className="font14 regular opacity-reduce">Assistance No: </label>
            <span className="font14 regular opacity">{trackClaimData?.AssistanceNo || ''}</span>
          </div>
        </div>
  
        <div className="border-content">
          {/* Timeline Border */}
          <div className="timeline-border">
            {trackHistory.map((event, index) => {
              const isLast = index === trackHistory.length - 1;
              const shouldHighlight = trackHistory.length > 0 && isLast;
  
              return (
                <div
                  key={index}
                  className={`timeline-item-border ${shouldHighlight ? 'highlight' : ''}`}
                >
                  <div className="timeline-dot" />
                  <div className="timeline-content" />
                </div>
              );
            })}
          </div>
  
          {/* Timeline Content */}
          <div className="timeline-content">
            {trackHistory.map((event, index) => {
              const isLast = index === trackHistory.length - 1;
              const shouldHighlight = trackHistory.length > 0 && isLast;
  
              return (
                <div
                  key={index}
                  className={`timeline-item-content ${shouldHighlight ? 'highlight' : ''}`}
                >
                  <div className="timeline-dotss" />
                  <div className="timeline-contentss">
                    <h4>{event.Action}</h4>
                    <label>Date time</label>
                    <p>{event.CreatedDate}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  
  
export default TrackClaim;